import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";
import { nmsMenus } from "globals/configuration/nms";




const operationURLS = {
  list: "/evaluation/list",
  update: "/evaluation/update",
  register: "/evaluation/create",
  delete: "/evaluation/delete",
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Question",
      accessor: "question",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Score",
      accessor: "score",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      width: 6,
      validation: formControl.string().required("Required").digitsOnly().nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getColumns, operationURLS };
